module.exports = __webpack_public_path__ + "static/media/logo-projekta.cd6d8bb7.svg";